import React from "react";
import { WidgetProps } from '@rjsf/core';

interface TextAreaDisplayProps extends WidgetProps {
  type?: string
}

const TextAreaDisplay = (props: TextAreaDisplayProps) => {
  const {
    id,
    placeholder,
    value,
    formContext
  } = props

  return <div id={id} className="TextAreaDisplay">{value || placeholder || formContext.emptyValue}</div>
}

export default TextAreaDisplay;
